import { render } from "./VUEModalCaricamentoDati.vue?vue&type=template&id=72e941ae"
import script from "./VUEModalCaricamentoDati.vue?vue&type=script&lang=js"
export * from "./VUEModalCaricamentoDati.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__